/* tslint:disable */

declare var Object: any;
export interface SettingServiceInterface {
  "id"?: number;
}

export class SettingService implements SettingServiceInterface {
  "id": number;
  constructor(data?: SettingServiceInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `SettingService`.
   */
  public static getModelName() {
    return "SettingService";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of SettingService for dynamic purposes.
  **/
  public static factory(data: SettingServiceInterface): SettingService{
    return new SettingService(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'SettingService',
      plural: 'SettingServices',
      path: 'SettingServices',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/SettingService.ts